import React from "react";
import { motion } from "framer-motion";
import { Reveal } from "../Reveal";
import { IMAGES } from "../../config/site";

const cards = [
  {
    key: "artist",
    role: "For the Artist",
    img: IMAGES.artist,
    headline: "You hold the pen.",
    body: "List your work, set your rules, and approve every product before it exists. Your name stays on your art — and so does the control.",
    tag: "Full sign-off",
  },
  {
    key: "designer",
    role: "For the Designer",
    img: IMAGES.designer,
    headline: "Collaborate, don't dilute.",
    body: "Partner with artists on official drops. Designer collabs run on a clean 50/50 split — credit and revenue shared down the middle.",
    tag: "50 / 50 split",
    gold: true,
  },
  {
    key: "fan",
    role: "For the Fan",
    img: IMAGES.fan,
    headline: "Wear it your way.",
    body: "Personalise garments within an artist's guidelines, or propose your own ideas. Own something official, made the moment you order it.",
    tag: "Made on demand",
  },
];

export const ThreeSided = () => {
  return (
    <section id="model" data-testid="model-section" className="relative py-28 md:py-40" style={{ backgroundColor: "#0E0A16" }}>
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <Reveal>
          <div className="max-w-[52ch] mb-16 md:mb-24">
            <div className="font-inter font-light text-[11px] uppercase tracking-[0.28em] mb-5" style={{ color: "#9B8FAC" }}>
              A three-sided world
            </div>
            <h2 className="font-inter font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.15]" style={{ color: "#F4EEF7", letterSpacing: "-0.01em" }}>
              Built for everyone in the room.
            </h2>
            <p className="font-inter font-light mt-6 text-base md:text-lg leading-relaxed" style={{ color: "#9B8FAC" }}>
              Artists, designers and fans each get a fair, defined role — a marketplace where great merch and honest credit finally live together.
            </p>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px" style={{ backgroundColor: "#2A2233" }}>
          {cards.map((c, i) => (
            <Reveal key={c.key} delay={i * 0.08}>
              <motion.article
                data-testid={`model-card-${c.key}`}
                whileHover={{ y: -6 }}
                transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                className="group h-full flex flex-col"
                style={{ backgroundColor: "#1A1424" }}
              >
                {/* Clipped, spotlit frame */}
                <div className="relative overflow-hidden" style={{ aspectRatio: "4 / 5" }}>
                  <img
                    src={c.img}
                    alt={c.role}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-105"
                    style={{ filter: "grayscale(0.55) contrast(1.15) brightness(0.82)" }}
                  />
                  <div
                    className="absolute inset-0"
                    style={{ background: "linear-gradient(180deg, rgba(14,10,22,0.15) 0%, rgba(14,10,22,0.55) 60%, #1A1424 100%)" }}
                  />
                  <span
                    className="absolute top-5 left-5 text-[11px] uppercase tracking-[0.28em] px-3 py-1"
                    style={{
                      color: c.gold ? "#F0C420" : "#F4EEF7",
                      border: `1px solid ${c.gold ? "#F0C420" : "#2A2233"}`,
                      backgroundColor: "rgba(14,10,22,0.6)",
                    }}
                  >
                    {c.tag}
                  </span>
                </div>

                <div className="flex-1 flex flex-col p-8">
                  <div className="text-[11px] uppercase tracking-[0.3em] mb-4" style={{ color: "#9B8FAC" }}>
                    {c.role}
                  </div>
                  <h3 className="font-display text-2xl md:text-3xl mb-4" style={{ color: "#F4EEF7" }}>
                    {c.headline}
                  </h3>
                  <p className="text-base leading-relaxed" style={{ color: "#9B8FAC" }}>
                    {c.body}
                  </p>
                </div>
              </motion.article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ThreeSided;
